import { StatusPanelAction } from '../actions/statusPanel'

export type StatusPanelState = {
  statusPanelOpen: boolean
}

const initialState: StatusPanelState = {
  statusPanelOpen: false,
}

export default function statusPanel(
  state = initialState,
  action: StatusPanelAction
): StatusPanelState {
  switch (action.type) {
    case 'CLOSE_STATUS_PANEL':
      return { statusPanelOpen: false }
    case 'OPEN_STATUS_PANEL':
      return { statusPanelOpen: true }
    default:
      return state
  }
}
